import { render, staticRenderFns } from "./LeaderboardTablePlayers.vue?vue&type=template&id=9d136792&scoped=true&"
import script from "./LeaderboardTablePlayers.vue?vue&type=script&lang=js&"
export * from "./LeaderboardTablePlayers.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardTablePlayers.vue?vue&type=style&index=0&id=9d136792&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d136792",
  null
  
)

export default component.exports